// extracted by mini-css-extract-plugin
export default {"wrapper":"yz2ZG","button":"au4J8","switcher":"ZhQud","gallery":"xaj5w","buttonText":"F8fPn","actived":"tdDzS","switch":"qNdVE","sizeM":"YxS5Y","sizeS":"Mn3Uj","placeholder":"Lvzuu"};